export default __webpack_public_path__ + "media/icons/home-icon-f48c61c9.svg";